export const enum CustomAttributeClassPrefix {
  Extra = 'extra',
  Extension = 'extend',
}
